import { Injectable } from '@angular/core';
import { Cxcencregcomp } from "../cxcinterfaces/cxcencregcomp";
import { Cxcdetregcomp } from "../cxcinterfaces/cxcdetregcomp";
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { isNullOrUndefined } from 'util';
@Injectable({
  providedIn: 'root'
})
export class CxcregcomprobanteService {

  public encregcomp: Cxcencregcomp[] = [];
  //public detregcomp: Cxcdetregcomp[][] = [];
  public _detregcomp: Cxcdetregcomp[];
  get detregcomp(): Cxcdetregcomp[] {
    return this._detregcomp;
  }

  set detregcomp(value: Cxcdetregcomp[]) {
    this._detregcomp = value;
  }
  private way: string;
  public regtotal
  constructor(
    private confIniciales: ConfInicialesService,
    private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
  ) {
    this.way = sessionStorage.getItem('way');
  }
  encontrarBanco(strCondicion): Observable<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/3aecc5fab55d98', {
      elementos: {
        condicion: strCondicion
      },

    }, this.confIniciales.httpOptions()
    );
  }
  insertarregistro(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/4afc76faadb3bc0000000000', {
      elementos: {
        p_encregcompro_numero: item.ENCREGCOMPRO_NUMERO,
        p_com_codigo: '01',
        p_encregcompro_fecha: item.ENCREGCOMPRO_FECHA,
        p_encregcompro_concepto: item.ENCREGCOMPRO_CONCEPTO,
        p_usuidentificacion: this.usuario.identificacion,
        p_ban_codigo: item.BAN_CODIGO,
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarregistrodet(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/257e3b7d56daee00000000000000', {
      elementos: {
        p_encregcompro_numero :item.ENCREGCOMPRO_NUMERO ,
        p_com_codigo :'01',
        p_ban_codigo :item.BAN_CODIGO ,
        p_DETREGCOMPRO_FECHA :item.DETREGCOMPRO_FECHA ,
        p_DETREGCOMPRO_REFERENCIA :item.DETREGCOMPRO_REFERENCIA ,
        p_DETREGCOMPRO_COMPROBANTE :item.DETREGCOMPRO_COMPROBANTE ,
        p_DETREGCOMPRO_CONCEPTO :item.DETREGCOMPRO_CONCEPTO ,
        p_detregcompro_referencia2 :item.DETREGCOMPRO_REFERENCIA2 ,
        p_cli_codigo :item.CLI_CODIGO ,
        p_DETREGCOMPRO_IMPORTE :item.DETREGCOMPRO_IMPORTE ,
        p_trncobro_nrodoc :item.TRNCOBRO_NRODOC 
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizarregistrodet(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/299df2ab2', {
      elementos: {
        p_encregcompro_numero :item.ENCREGCOMPRO_NUMERO ,
        p_com_codigo :'01',
        p_ban_codigo :item.BAN_CODIGO ,
        p_DETREGCOMPRO_COMPROBANTE :item.DETREGCOMPRO_COMPROBANTE ,
        p_detregcompro_referencia2 :item.DETREGCOMPRO_REFERENCIA2 ,
        p_cli_codigo :item.CLI_CODIGO
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getenccoprobante(strnumero): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/10775d763316cf00000000', {
      elementos: {
        numero: strnumero
      },

    }, this.confIniciales.httpOptions()
    ).toPromise();;
  }
  getdetcoprobante(strnumero): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/10775aeeb316cf00000000', {
      elementos: {
        numero: strnumero
      },

    }, this.confIniciales.httpOptions()
    ).toPromise();;
  }
  registrartemporal(item): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/1b74198b67785b00000000', {
      elementos: {
        p_DETREGCOMPRO_FECHA : item.DETREGCOMPRO_FECHA,
        p_DETREGCOMPRO_REFERENCIA : item.DETREGCOMPRO_REFERENCIA,
        p_DETREGCOMPRO_COMPROBANTE : item.DETREGCOMPRO_COMPROBANTE,
        p_DETREGCOMPRO_CONCEPTO: item.DETREGCOMPRO_CONCEPTO,
        p_DETREGCOMPRO_IMPORTE : item.DETREGCOMPRO_IMPORTE,
        p_USUIDENTIFICACION: this.usuario.identificacion,
        
      },

    }, this.confIniciales.httpOptions()
    ).toPromise();;
  }
  borrarRegistro(registro): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/178ded5bdba12e0000', {
      elementos: {
        p_encregcompro_numero :registro ,
        p_com_codigo:'01'
        
      },

    }, this.confIniciales.httpOptions()
    ).toPromise();;
  }
  eliminatemporal(): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/1d595a5756d98b00000000000000', {
      elementos: {
        p_USUIDENTIFICACION: this.usuario.identificacion
      },

    }, this.confIniciales.httpOptions()
    ).toPromise();;
  }
  getregistrartemporal(): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/83bbb7425ceed800000000000', {
      elementos: {
        p_USUIDENTIFICACION: this.usuario.identificacion,
        p_com_codigo:'01'
      },

    }, this.confIniciales.httpOptions()
    ).toPromise();;
  }
  parseToIntAndScalecom(n) {
    const s = String(n);
    if (s.indexOf('e') !== -1) {
      return this.parseToIntAndScalecom(Number(s).toFixed(18).replace(/0+$/, ''));
    }
    const parts = s.split('.');
    const scale = parts[1] ? parts[1].length : 0
    const intVal = Number(parts.join(''));
    return { intVal, scale }
  }
  toScalate(n,decimales){
    if (isNullOrUndefined(n) || n === '') {
      return 0
    }
    const p =this.parseToIntAndScalecom(n);
    if (p.scale === decimales) {
      return p.intVal
    }
    if (p.scale < decimales) {
      return p.intVal * Math.pow(10,decimales - p.scale)
    }else{
      const factor = Math.pow(10, p.scale - decimales)
      return Math.round(p.intVal / factor)
    }
  }
  calculartota(){
    let total=0
    for (const iterator of this.detregcomp) {
      total+=this.toScalate(iterator.DETREGCOMPRO_IMPORTE,2)
    }
    this.regtotal=Number (total /  Math.pow(10,2)).toFixed(2)
  }
  eliminadetregistro(item): Promise<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/1d595a57535dde000000000', {
      elementos: {
        p_encregcompro_numero :item.ENCREGCOMPRO_NUMERO,
        p_com_codigo :'01',
        p_ban_codigo :item.BAN_CODIGO,
        p_DETREGCOMPRO_COMPROBANTE :item.DETREGCOMPRO_COMPROBANTE
        
      },

    }, this.confIniciales.httpOptions()
    ).toPromise();;
  }
}
